import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Page from 'components/Page';
import LabelList from 'components/LabelList';

import { withData } from 'lib';
import { SettingsLabelListPageQuery } from '__generated__/SettingsLabelListPageQuery.graphql';

const query = graphql`
  query SettingsLabelListPageQuery {
    ...LabelList_data
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<SettingsLabelListPageQuery>;
};

const SettingsLabelListPage: FC<Props> = ({ preloadedQuery }) => {
  const data = usePreloadedQuery<SettingsLabelListPageQuery>(
    query,
    preloadedQuery
  );

  return (
    <Page
      breadcrumbs={[
        { link: '/settings', name: 'Nustatymai' },
        { name: 'Etiketės' },
      ]}>
      <LabelList data={data} />
    </Page>
  );
};

export default withData<SettingsLabelListPageQuery>({
  query,
})(SettingsLabelListPage);
